require('./src/jquery');